import React, { useEffect, useRef, useState } from "react";
import styles from "../styles/SeatSelector.module.css";
import SeatIcon from "../images/seat.svg?react";
import { getSeatCounts } from "../api/formApi";

const SeatSelector = ({
  scheduleId = null,
  onChange,
  maxSeats: propMaxSeats = null,
  takenSeats: propTakenSeats = 0,
  label = "Кол-во мест",
  initialCount = 1,
}) => {
  const [maxSeats, setMaxSeats] = useState(0);
  const [takenSeats, setTakenSeats] = useState(0);
  const [hoveredIndex, setHoveredIndex] = useState(0);
  const [selectedCount, setSelectedCount] = useState(initialCount);

  // Храним актуальный onChange в ref, чтобы не триггерить effect по ссылке функции
  const onChangeRef = useRef(onChange);

  useEffect(() => {
    onChangeRef.current = onChange;
  }, [onChange]);

  useEffect(() => {
    if (scheduleId) {
      const fetchSeatData = async () => {
        try {
          const data = await getSeatCounts(scheduleId);
          const max = data.data.countMaxPlace;
          const taken = data.data.countCurrentPlace;

          setMaxSeats(max);
          setTakenSeats(taken);

          const available = max - taken;

          if (available <= 0) {
            setSelectedCount(0);
            return;
          }

          // Если initialCount больше доступного — зажимаем
          setSelectedCount((prev) => {
            const base = prev || initialCount || 1;
            return Math.min(base, available);
          });
        } catch (err) {
          console.error("Ошибка загрузки мест:", err);
        }
      };

      fetchSeatData();
    } else if (propMaxSeats !== null) {
      const max = Number(propMaxSeats) || 0;
      const taken = Number(propTakenSeats) || 0;

      setMaxSeats(max);
      setTakenSeats(taken);

      const available = max - taken;

      if (available <= 0) {
        setSelectedCount(0);
        return;
      }

      setSelectedCount((prev) => {
        const base = prev || initialCount || 1;
        return Math.min(base, available);
      });
    }
  }, [scheduleId, propMaxSeats, propTakenSeats, initialCount]);

  // ✅ Вызываем onChange только при изменении selectedCount
  useEffect(() => {
    onChangeRef.current?.(selectedCount);
  }, [selectedCount]);

  const handleMouseEnter = (index) => {
    setHoveredIndex((prev) => (prev === index ? prev : index));
  };

  const handleMouseLeave = () => {
    setHoveredIndex((prev) => (prev === 0 ? prev : 0));
  };

  const handleClick = (index) => {
    setSelectedCount((prev) => (prev === index ? prev : index));
  };

  const availableSeatsCount = Math.max(0, maxSeats - takenSeats);
  const availableSeats = Array.from({ length: availableSeatsCount }, (_, i) => i + 1);
  const takenSeatPlaceholders = Array.from({ length: Math.max(0, takenSeats) }, (_, i) => i + 1);

  return (
    <div className={styles.seatWrapper + " input"}>
      {label && <label className={styles.label}>{label}</label>}

      <div className={styles.seats}>
        {availableSeats.map((seatNumber) => {
          const isActive = seatNumber <= (hoveredIndex || selectedCount);

          return (
            <span
              key={`available-${seatNumber}`}
              className={`${styles.seat} ${isActive ? styles.active : ""}`}
              onMouseEnter={() => handleMouseEnter(seatNumber)}
              onMouseLeave={handleMouseLeave}
              onClick={() => handleClick(seatNumber)}
            >
              <SeatIcon className={styles.seatIcon} />
            </span>
          );
        })}

        {takenSeatPlaceholders.map((_, idx) => (
          <span key={`taken-${idx}`} className={`${styles.seat} ${styles.disabled}`}>
            <SeatIcon className={`${styles.seatIcon} ${styles.disabledIcon}`} />
          </span>
        ))}
      </div>
    </div>
  );
};

export default SeatSelector;